<div class="d-flex margin-empty-spaces" *ngIf="!isLoading">
  <i class="material-icons font-size-icon-empty-spaces notranslate">info</i>
  <p class="empty-spaces">{{this.keyText | translate}}</p>
</div>
<div class="d-flex margin-empty-spaces" *ngIf="isLoading">
  <i class="material-icons font-size-icon-empty-spaces notranslate">hourglass_bottom</i>
  <p class="empty-spaces">{{'EMPTY_SPACES.LOADING_TEXT' | translate}}</p>
</div>
<div class="d-flex cta-container" *ngIf="this.hasCta && !isLoading">
  <button class="btn btn-fill btn-primary" mat-raised-button type="button" (click)="this.callCta()">
    {{this.ctaButtonTextKey | translate}}
  </button>
</div>
